export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#2D3730] text-[#E8E3DA] py-16 md:py-20"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-12 gap-8 md:gap-12 items-start">
          <div className="col-span-12 md:col-span-5">
            <img
              src="/fabfathers-logo.png"
              alt="FabFathers"
              className="h-16 md:h-20 w-auto object-contain"
              style={{ filter: "invert(1) hue-rotate(180deg) brightness(1.1)" }}
            />
            <p className="mt-5 max-w-[380px] text-[#E8E3DA]/70 text-sm md:text-base leading-relaxed font-light">
              A movement to redefine fatherhood — from provider to emotionally present
              guide. One ordinary moment at a time.
            </p>
          </div>

          <div className="col-span-6 md:col-span-3 md:col-start-7">
            <p className="text-[11px] uppercase tracking-[0.3em] text-[#8A9A86] mb-5">
              Sections
            </p>
            <ul className="space-y-3 text-sm">
              {["mission", "vision", "purpose", "ripple", "founder", "join"].map((id) => (
                <li key={id}>
                  <a
                    href={`#${id}`}
                    data-testid={`footer-link-${id}`}
                    onClick={(e) => {
                      e.preventDefault();
                      document
                        .getElementById(id)
                        ?.scrollIntoView({ behavior: "smooth" });
                    }}
                    className="link-underline capitalize"
                  >
                    {id}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="col-span-6 md:col-span-3">
            <p className="text-[11px] uppercase tracking-[0.3em] text-[#8A9A86] mb-5">
              Contact
            </p>
            <a
              href="mailto:Support@fabfathers.com"
              data-testid="footer-email"
              className="link-underline text-sm"
            >
              Support@fabfathers.com
            </a>
          </div>
        </div>

        <div className="mt-16 border-t border-[#F9F8F6]/15 pt-6 flex flex-wrap items-center justify-between gap-3">
          <p className="text-xs text-[#E8E3DA]/60 font-light">
            © {new Date().getFullYear()} FabFathers. Built with care, for the fathers who
            choose to show up.
          </p>
          <p className="font-serif-display italic text-[#E8E3DA]/70 text-sm">
            A movement, not a moment.
          </p>
        </div>
      </div>
    </footer>
  );
};
